import { atom } from "recoil";

export const InvestmentSectorState = atom({
  key: "InvestmentSectorState",
  default: undefined,
});
